import EmailForm from '../Form/Implementations/EmailForm';
import Layout from '../Layout';
import PageTemplate from '../PageTemplate';
import RecoveryLayout from './Layout';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { validateEmail } from '../Form/Validation';

interface Props {
  handleSubmit: (email: string) => void;
  error: string;
}

const StartRecovery = ({ handleSubmit, error }: Props): JSX.Element => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const isEmailValid = validateEmail(email);
  const formatError = Boolean(!email) || isEmailValid ? '' : t('profile.email.error');

  return (
    <Layout>
      <RecoveryLayout>
        <PageTemplate
          title={t('auth.restore.password')}
          description={t('auth.we.send.code')}
          form={
            <EmailForm email={email} handleChange={setEmail} isEmailValid={isEmailValid} error={formatError || error} />
          }
          submitButtonContent={t('auth.send.code')}
          submit={() => handleSubmit(email)}
          disableSubmit={Boolean(!email || !isEmailValid)}
        />
      </RecoveryLayout>
    </Layout>
  );
};

export default StartRecovery;
